import { BootFileParams } from '@quasar/app-webpack';
import { AxiosInstanceKey } from 'SharedDir/constants/common';
import { useAuthStore } from 'SharedDir/stores/auth.store';
import { RouteLocationRaw } from 'vue-router';

import { createErrorInterceptor } from './error.interceptors';
import { acquireHttp } from './http';

export default <TState>(
  context: BootFileParams<TState>,
  afterLogout: (redirectTo: string) => RouteLocationRaw | Promise<RouteLocationRaw>
) => {
  console.debug('Booting axios...');
  const authStore = useAuthStore(context.store);

  // На сервере это новый экземпляр, привязанный к текущему запросу, в браузере — общий на вкладку.
  // Интерсепторы вешаются на него, а не на модульный axios, иначе в SSR они копятся от запроса к запросу
  // и уносят токен одного пользователя в запросы другого
  const http = acquireHttp();

  context.app.config.globalProperties.$axios = http;

  http.interceptors.request.use((request) => {
    if (!authStore.isAuthenticated) {
      return request;
    }

    request.headers.Authorization = `Bearer ${authStore.token}`;
    return request;
  });

  http.interceptors.response.use(
    (response) => response,
    createErrorInterceptor(http, context, afterLogout)
  );

  context.app.provide(AxiosInstanceKey, http);
};
